import { ApprovalsMaterializedApprovalFlowHistoryFragment } from 'generated/resources/graphql'

import { AutoApproved } from './AutoApproved'
import { FinalDecision } from './FinalDecision'
import { Steps } from './Steps'

interface ContentProps {
  materializedApprovalFlow: ApprovalsMaterializedApprovalFlowHistoryFragment
  newLook?: boolean
}

export const Content = ({ materializedApprovalFlow, newLook }: ContentProps) => {
  const autoApproved = materializedApprovalFlow.rulesDecision === 'auto_approve'
  const historyComponent = () => {
    return autoApproved ? (
      <AutoApproved description={materializedApprovalFlow.autoApprovalDescription} />
    ) : (
      <Steps materializedApprovalFlow={materializedApprovalFlow} newLook={newLook} />
    )
  }

  return (
    <>
      {historyComponent()}
      {!newLook && materializedApprovalFlow.finalDecisionAt && (
        <FinalDecision
          status={materializedApprovalFlow.status}
          finalDecisionAt={materializedApprovalFlow.finalDecisionAt}
        />
      )}
    </>
  )
}
